<template>
    <div>
        <!-- 核心标语区 -->
        <!-- <section class="bg-gradient-to-br from-[#0D47A1] to-[#1E88E5] py-20 text-white">
            <div class="max-w-[1200px] mx-auto px-4">
                <h2 class="text-4xl font-bold mb-6">金融对接模块</h2>
                <p class="text-xl text-blue-100 max-w-2xl leading-relaxed opacity-90">
                    打通数据资产化最后“一公里”，连接优质金融机构，赋能公共数据资产实现质押融资、信贷增信及证券化转换。
                </p>
            </div>
        </section> -->
                <section class="bg-gradient-to-r from-[#0D47A1] to-[#1976D2] py-20 text-white">
            <div class="max-w-[1200px] mx-auto px-4 flex items-center justify-between">
                <div class="max-w-2xl">

                    <h2 class="text-4xl font-bold mb-6">金融产品对接</h2>
                    <p class="text-xl text-blue-100 leading-relaxed opacity-90">
                        打通数据资产化最后“一公里”，连接优质金融机构，赋能公共数据资产实现质押融资、信贷增信及证券化转换。
                    </p>
                </div>
                <div class="hidden lg:block">
                    <span class="iconify text-[160px] text-white/20" data-icon="ri:bank-line"></span>
                </div>
            </div>
        </section>

        <!-- 金融机构产品列表 -->
        <section class="py-16 bg-white">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="text-center mb-12">
                    <h2 class="text-3xl font-bold mb-4 text-gray-800">金融机构产品对接</h2>
                    <p class="text-gray-600 max-w-2xl mx-auto">精选合作金融机构，提供专业金融产品服务</p>
                </div>
                <div class="overflow-x-auto">
                    <table class="w-full border-collapse">
                        <thead>
                            <tr class="bg-gray-100">
                                <th class="p-4 text-left border-b border-gray-200">金融机构</th>
                                <th class="p-4 text-left border-b border-gray-200">产品类型</th>
                                <th class="p-4 text-left border-b border-gray-200">特色产品</th>
                                <th class="p-4 text-left border-b border-gray-200">服务周期</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="border-b border-gray-100 hover:bg-gray-50">
                                <td class="p-4 font-medium">工商银行</td>
                                <td class="p-4">银行信贷</td>
                                <td class="p-4">数据资产质押贷、供应链金融贷</td>
                                <td class="p-4">3-5个工作日</td>
                            </tr>
                            <tr class="border-b border-gray-100 hover:bg-gray-50">
                                <td class="p-4 font-medium">建设银行</td>
                                <td class="p-4">银行信贷</td>
                                <td class="p-4">快速审批贷、科技创新贷</td>
                                <td class="p-4">2-4个工作日</td>
                            </tr>
                            <tr class="border-b border-gray-100 hover:bg-gray-50">
                                <td class="p-4 font-medium">中信证券</td>
                                <td class="p-4">投资银行</td>
                                <td class="p-4">数据资产ABS、股权投资</td>
                                <td class="p-4">6-12个月</td>
                            </tr>
                            <tr class="border-b border-gray-100 hover:bg-gray-50">
                                <td class="p-4 font-medium">华泰投行</td>
                                <td class="p-4">投资银行</td>
                                <td class="p-4">数据基金投资、并购顾问</td>
                                <td class="p-4">3-6个月</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- 平台专业优势 -->
            <section class="py-16 bg-gray-50">
                <div class="max-w-[1200px] mx-auto px-4">
                    <div class="text-center mb-12">
                        <h2 class="text-3xl font-bold mb-4 text-gray-800">平台专业优势</h2>
                        <p class="text-gray-600 max-w-2xl mx-auto">基于对金融产品的深度认知，提供专业精准的对接服务</p>
                    </div>

                    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
                        <div class="bg-white p-8 border-l-4 border-blue-600 shadow-sm">
                            <h3 class="text-xl font-bold text-gray-800 mb-4">产品深度认知</h3>
                            <p class="text-gray-600 mb-4">熟悉2000余种金融产品细节，包括：</p>
                            <ul class="space-y-2 text-gray-500">
                                <li class="pl-4 relative before:content-['•'] before:absolute before:left-0">20余家银行机构产品
                                </li>
                                <li class="pl-4 relative before:content-['•'] before:absolute before:left-0">15家券商投行服务
                                </li>
                                <li class="pl-4 relative before:content-['•'] before:absolute before:left-0">10家保险公司增信产品
                                </li>
                            </ul>
                        </div>

                        <div class="bg-white p-8 border-l-4 border-blue-600 shadow-sm">
                            <h3 class="text-xl font-bold text-gray-800 mb-4">专业分析评估</h3>
                            <p class="text-gray-600 mb-4">基于多维度的专业分析：</p>
                            <ul class="space-y-2 text-gray-500">
                                <li class="pl-4 relative before:content-['•'] before:absolute before:left-0">企业资质与需求分析
                                </li>
                                <li class="pl-4 relative before:content-['•'] before:absolute before:left-0">数据资产价值评估
                                </li>
                                <li class="pl-4 relative before:content-['•'] before:absolute before:left-0">融资成本优化方案
                                </li>
                            </ul>
                        </div>

                        <div class="bg-white p-8 border-l-4 border-blue-600 shadow-sm">
                            <h3 class="text-xl font-bold text-gray-800 mb-4">精准对接服务</h3>
                            <p class="text-gray-600 mb-4">提供全流程专业服务：</p>
                            <ul class="space-y-2 text-gray-500">
                                <li class="pl-4 relative before:content-['•'] before:absolute before:left-0">500余个成功对接案例
                                </li>
                                <li class="pl-4 relative before:content-['•'] before:absolute before:left-0">95%以上的客户满意度
                                </li>
                                <li class="pl-4 relative before:content-['•'] before:absolute before:left-0">全程专业顾问支持
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="text-center mt-12">
                        <button @click="showMessageModal = true"
                            class="bg-blue-600 text-white px-8 py-3 rounded-md font-medium hover:bg-blue-700 transition-colors">
                            在线专家咨询
                        </button>
                    </div>
                </div>
            </section>
        </section>


                <!-- 在线留言弹窗 -->
        <div v-if="showMessageModal"
            class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div class="bg-white rounded-2xl w-full max-w-md shadow-2xl">
                <!-- 弹窗头部 -->
                <div class="flex items-center justify-between p-6 border-b border-gray-100">
                    <div class="flex items-center space-x-3">
                        <div class="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center text-[#1565C0]">
                            <span class="iconify text-xl" data-icon="ri:message-3-line"></span>
                        </div>
                        <h3 class="text-xl font-bold text-gray-800">专家咨询</h3>
                    </div>
                    <button @click="showMessageModal = false"
                        class="text-gray-400 hover:text-gray-600 transition-colors">
                        <span class="iconify text-2xl" data-icon="ri:close-line"></span>
                    </button>
                </div>

                <!-- 表单内容 -->
                <div class="p-6">
                    <form @submit.prevent="submitMessage" class="space-y-5">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-2">姓名 <span style="color: red;">*</span></label>
                            <input v-model="messageForm.name" type="text" required
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                placeholder="请输入您的姓名">
                        </div>

                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-2">联系方式 <span style="color: red;">*</span></label>
                            <input v-model="messageForm.contact" type="text" required
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                placeholder="请输入手机号或邮箱">
                        </div>

                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-2">公司/机构</label>
                            <input v-model="messageForm.company" type="text"
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                placeholder="请输入公司或机构名称（选填）">
                        </div>

                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-2">咨询内容 <span style="color: red;">*</span></label>
                            <textarea v-model="messageForm.content" required rows="4"
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all resize-none"
                                placeholder="请简要描述您的数据资产价值评估咨询需求..."></textarea>
                        </div>

                        <div class="pt-2">
                            <button type="submit" :disabled="isSubmitting"
                                class="w-full bg-[#1565C0] text-white py-3 rounded-lg font-bold hover:bg-[#0D47A1] transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                                <span v-if="!isSubmitting">提交咨询</span>
                                <span v-else class="flex items-center justify-center">
                                    <span class="iconify animate-spin mr-2" data-icon="ri:loader-4-line"></span>
                                    提交中...
                                </span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- 提交成功提示 -->
        <div v-if="showSuccessToast" class="fixed top-6 right-6 z-50 animate-slide-in">
            <div class="bg-green-50 border border-green-200 rounded-xl p-4 shadow-lg flex items-center space-x-3">
                <div class="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center text-green-600">
                    <span class="iconify text-xl" data-icon="ri:checkbox-circle-fill"></span>
                </div>
                <div>
                    <p class="font-medium text-green-800">咨询提交成功！</p>
                    <p class="text-sm text-green-600">我们将尽快与您联系</p>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
export default {

    data() {
        return {
            // 新增：留言弹框相关数据
            showMessageModal: false,
            showSuccessToast: false,
            isSubmitting: false,
            messageForm: {
                name: '',
                contact: '',
                company: '',
                content: ''
            },
            scrollTop: 0
        }
    },
    methods: {
       async submitMessage() {
            if (this.isSubmitting) return;

            this.isSubmitting = true;

            try {
                // 构建咨询数据
                const consultationData = {
                    name: this.messageForm.name,
                    contact: this.messageForm.contact,
                    problemDescription: this.messageForm.content,
                    subjectName: this.messageForm.company || '未填写',
                    consultationTime: this.getCurrentTime(),
                    status: 0 // 默认未处理
                };

                console.log('提交咨询请求参数:', consultationData);

                // 调用API接口
                const response = await this.$axios.post('/web/consultation/save', consultationData);
                console.log('提交咨询响应:', response.data);

                if (response.data && response.data.status === 200) {
                    // 显示成功提示
                    this.showSuccessToast = true;

                    // 重置表单
                    this.messageForm = {
                        name: '',
                        contact: '',
                        company: '',
                        content: ''
                    };

                    // 关闭弹窗
                    this.showMessageModal = false;

                    // 3秒后自动隐藏成功提示
                    setTimeout(() => {
                        this.showSuccessToast = false;
                    }, 3000);
                } else {
                    this.$message.error(response.data?.msg || '提交咨询失败');
                }

            } catch (error) {
                console.error('提交咨询失败:', error);
                this.$message.error('提交咨询失败，请稍后重试');
            } finally {
                this.isSubmitting = false;
            }
        },

        // 获取当前时间（新增方法）
        getCurrentTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }
    },


}
</script>

<style lang="scss">


// 弹窗动画
.fixed.inset-0 {
    animation: fadeIn 0.3s ease-out;

    .bg-white {
        animation: slideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }
}

// 成功提示动画
.animate-slide-in {
    animation: slideInRight 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px) scale(0.95);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes slideInRight {
    from {
        opacity: 0;
        transform: translateX(100%);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

// 响应式调整
@media (max-width: 768px) {
    // 弹窗响应式
    .fixed.inset-0 {
        padding: 1rem;
        align-items: flex-end;

        .bg-white {
            width: 100%;
            max-width: 100%;
            border-radius: 1rem 1rem 0 0;
            animation: slideUpMobile 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }
    }

    @keyframes slideUpMobile {
        from {
            transform: translateY(100%);
        }

        to {
            transform: translateY(0);
        }
    }

    // 成功提示响应式
    .fixed.top-6.right-6 {
        top: auto;
        bottom: 1rem;
        right: 1rem;
        left: 1rem;
        animation: slideUpMobile 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }
}

// 平板设备适配
@media (min-width: 769px) and (max-width: 1024px) {
    .fixed.inset-0 {
        .bg-white {
            max-width: 90%;
        }
    }
}

    
</style>